import { gql } from '@apollo/client';

  export const GET_HOME_DATA = gql`
  query myQuery($in_id_enterprise: Int) {
    h_piot_home(args: {in_id_enterprise: $in_id_enterprise}) {
      in_id_enterprise
      sites
    }
  }
  `;